
import React from 'react';
import { Icons } from '../ui/Icons';

const LoadingSpinner: React.FC<{ message?: string }> = ({ message = 'Loading...' }) => {
    return (
        <div className="fixed inset-0 bg-white bg-opacity-75 dark:bg-slate-900 dark:bg-opacity-75 flex flex-col items-center justify-center z-50">
            <Icons.Loader className="h-12 w-12 text-indigo-600 animate-spin" />
            <p className="mt-4 text-lg font-medium text-gray-700 dark:text-gray-300">{message}</p>
        </div>
    );
};

export default LoadingSpinner;